import PropTypes from 'prop-types';

export default {
  Image: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.number,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    focalPointX: PropTypes.number,
    focalPointY: PropTypes.number,
    fileSize: PropTypes.number,
    fileHash: PropTypes.string,
  }),
  Link: PropTypes.shape({
    openInNewWindow: PropTypes.bool,
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  NavItem: PropTypes.shape({
    active: PropTypes.bool,
    href: PropTypes.string,
    label: PropTypes.text,
  }),
  Document: PropTypes.shape({
    fileSize: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  Section: {
    eyebrow: PropTypes.string,
    h2: PropTypes.string,
    description: PropTypes.string,
  },
  Product: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.object,
    url: PropTypes.string,
  })
};
